import { RootState } from "@/reducers";
import { useRouter } from "@/shared/utils/hooks/useRouter";
import { formatMoney, formatSTK } from "@/shared/utils/ultils";
import { CButton, CFormInput, CLoadingButton } from "@coreui/react-pro";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "@/shared/config/axios-interceptor";
import { ToastInfo } from "@/components/shared/toast/Toast";
import { AppDispatch } from "@/store";
import { getProfile } from "../auth/auth.api";
const Withdraw = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.authentication);
  const { navigate } = useRouter();
  const [amount, setAmount] = useState('');
  const [paypassword, setPayPassword] = useState('');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!user?.bankName) {
      navigate("/bank");
    }
  }, [user]);

  const handleWithdraw = async () => {
    if(Number(amount) <= 0){
        ToastInfo("Số tiền phải lớn hơn 0");
        return;
    }

    if(!paypassword){
        ToastInfo("Vui lòng nhập mật khẩu rút tiền");
        return;
    }

    try{
        setLoading(true);
        await axios.post("/transaction/withdraw", {
            money: amount,
            paypassword
        });
        ToastInfo("Gửi rút tiền thành công");
        setLoading(false)
        setAmount('');
        setPayPassword('');
        dispatch(getProfile());
    }catch(e){
        setLoading(false);
        console.log(e)
    }
  };

  return (
    <div className="wrapper">
      <div className="container-web bg2 bank">
        <div
          className="d-flex align-items-center justify-content-between px-3"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 999,
            background: "#0262b0",
            height: 50,
            maxWidth: 500,
            margin: "auto",
            color: "#fff",
          }}
        >
          <Link to="/account">
            <i
              style={{ color: "#fff" }}
              className="fa-solid fa-chevron-left"
            ></i>
          </Link>
          <div>RÚT TIỀN</div>
          <div></div>
        </div>
        <div style={{ paddingTop: 50 }}></div>

        <div className="p-3" style={{ fontSize: 14 }}>
          <div className="d-flex justify-content-between border-bottom pb-2 mb-2 gap-2" style={{ fontSize: 12 }}>
            <span style={{ whiteSpace: "nowrap" }}>Ngân hàng</span>
            <span>{user?.bankName}</span>
          </div>

          <div className="d-flex justify-content-between border-bottom pb-2 mb-2 gap-2" style={{ fontSize: 12 }}>
            <span style={{ whiteSpace: "nowrap" }}>Chủ tài khoản</span>
            <span>{user?.cardName}</span>
          </div>

          <div className="d-flex justify-content-between border-bottom pb-2 mb-2 gap-2" style={{ fontSize: 12 }}>
            <span style={{ whiteSpace: "nowrap" }}>Số tài khoản</span>
            <span>{formatSTK(user?.cardNumber)}</span>
          </div>

          <div className="mt-5">
            <div>Nhập số tiền rút</div>
            <CFormInput
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="form-height-44 w-100 mt-2"
              style={{
                width: "100%",
                background: "transparent",
                color: "#fff",
                boxShadow: "none",
              }}
            />
            <div className="text-end mt-1 text-sm" style={{ color: "#fff" }}>
              Số dư: {formatMoney(user?.money ?? 0)}$
            </div>
          </div>

          <div className="mt-2">
            <div>Mật khẩu rút tiền</div>
            <CFormInput
              type="password"
              value={paypassword}
              onChange={(e) => setPayPassword(e.target.value)}
              className="form-height-44 w-100 mt-2"
              style={{
                width: "100%",
                background: "transparent",
                color: "#fff",
                boxShadow: "none",
              }}
            />
          </div>

          <CLoadingButton
            onClick={handleWithdraw}
            className="w-100 rounded-3 mt-4"
            style={{ background: "#0262b0" }}
            loading={loading}
            disabled={loading}
          >
            RÚT TIỀN
          </CLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default Withdraw;
